import { render } from "./isu.vue?vue&type=template&id=107b12c1&scoped=true"
import script from "./isu.vue?vue&type=script&lang=js"
export * from "./isu.vue?vue&type=script&lang=js"

import "./isu.vue?vue&type=style&index=0&id=107b12c1&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107b12c1"]])

export default __exports__